import { SVGProps } from "react";

export function WalletCardsIllustration(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width={88} height={88} viewBox="0 0 88 88" fill="none" {...props}>
      <circle cx={44} cy={44} r={36} fill="#DEDFE0" opacity={0.2} />
      <path
        fill="#AACFD3"
        fillRule="evenodd"
        d="M18 16a2 2 0 0 0-2 2v12a2 2 0 0 1 2-2h52a2 2 0 0 1 2 2V18a2 2 0 0 0-2-2H18Z"
        clipRule="evenodd"
      />
      <circle cx={23.148} cy={22} r={3} fill="#fff" />
      <rect width={36} height={4} x={30} y={20} fill="#F7F8F8" rx={2} />
      <path
        fill="#AACFD3"
        fillRule="evenodd"
        d="M18 30a2 2 0 0 0-2 2v12a2 2 0 0 1 2-2h52a2 2 0 0 1 2 2V32a2 2 0 0 0-2-2H18Z"
        clipRule="evenodd"
      />
      <circle cx={23.148} cy={36} r={3} fill="#fff" />
      <rect width={36} height={4} x={30} y={34} fill="#F7F8F8" rx={2} />
      <rect width={56} height={32} x={16} y={44} fill="#3E8D96" rx={2} />
      <circle cx={23} cy={53} r={3} fill="#fff" />
      <rect
        width={36}
        height={4}
        x={30}
        y={50}
        fill="#F7F8F8"
        opacity={0.9}
        rx={2}
      />
      <rect
        width={25}
        height={3}
        x={30}
        y={58}
        fill="#F7F8F8"
        opacity={0.6}
        rx={1.5}
      />
      <rect
        width={25}
        height={3}
        x={30}
        y={63}
        fill="#F7F8F8"
        opacity={0.6}
        rx={1.5}
      />
      <rect
        width={25}
        height={3}
        x={30}
        y={68}
        fill="#F7F8F8"
        opacity={0.6}
        rx={1.5}
      />
      <defs />
    </svg>
  );
}
